import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Assets/Styles/Login.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AxiosInstance from "../Axios/AxiosInstance";

const SESSION_KEYS = [
    "token", "username", "user_companyid", "user_plantid", "user_emailid",
    "user_id", "role_id", "urid", "first_name",
];

// At least 8 chars: lowercase, uppercase, digit and one of @$!%*?&
const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        SESSION_KEYS.forEach((k) => sessionStorage.removeItem(k));
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrors({});
        if (!passwordRegex.test(password)) {
            setErrors({
                password:
                    "Use at least 8 characters with an uppercase letter, a lowercase letter, a number and one of @$!%*?&",
            });
            return;
        }
        await checkUserLogin(username.trim(), password);
    };

    const checkUserLogin = async (userName, userPassword) => {
        setLoading(true);
        try {
            const response = await AxiosInstance.get(
                `/Login?un=${encodeURIComponent(userName)}&up=${encodeURIComponent(userPassword)}`
            );
            const list = Array.isArray(response.data) ? response.data : [];
            const user = list.find(
                (u) => u.userEmailID === userName && u.userPassword === userPassword
            );
            if (!user) {
                setErrors({ form: "User name or password is incorrect." });
                return;
            }
            sessionStorage.setItem("user_companyid", user.userCompanyID);
            sessionStorage.setItem("user_plantid", user.userPlantID);
            sessionStorage.setItem("user_emailid", user.userEmailID);
            sessionStorage.setItem("user_id", user.userID);
            sessionStorage.setItem("role_id", user.userRoleID);
            sessionStorage.setItem("urid", user.uRID);
            sessionStorage.setItem("first_name", user.userFirstName);
            sessionStorage.setItem("token", user.jwtToken);
            sessionStorage.setItem("username", user.userEmailID);

            if (user.userRoleID == null || user.userPlantID == null) {
                setErrors({ form: "Your account has no plant or role assigned. Contact your administrator." });
                return;
            }
            if (String(user.uRID) === "10") navigate("/search-plant");
            else navigate(`/home?pid=${user.userPlantID}`);
        } catch (error) {
            console.log(error);
            setErrors({ form: "Cannot reach the server. Check your connection and try again." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="lg-page">
            <div className="lg-shell">
                <aside className="lg-brandpanel">
                    <span className="lg-eyebrow">Robot for Welfare of Soil</span>
                    <h1>Welcome back to Bhuhit</h1>
                    <p>Your fields and robots, in one place.</p>
                    <ul>
                        {/*<li><i className="fa fa-globe" aria-hidden="true" /><div><strong>Satellite Agri Dashboard</strong><span>Crop health and soil data for every field</span></div></li>*/}
                        <li><i className="fa fa-cloud" aria-hidden="true" /><div><strong>Cloud robot operation</strong><span>Grass cutting, spraying and sowing</span></div></li>
                        <li><i className="fa fa-bar-chart" aria-hidden="true" /><div><strong>Reports and analytics</strong><span>Clear results you can measure</span></div></li>
                    </ul>
                </aside>
                <form className="lg-card" onSubmit={handleSubmit} noValidate>
                    <h2>Sign in</h2>
                    <p className="lg-sub-card">Enter your account details to open the Bhuhit console.</p>

                    {errors.form && <div className="lg-error-box" role="alert">{errors.form}</div>}

                    <div className="lg-field">
                        <label htmlFor="username">User name</label>
                        <div className="lg-input">
                            <i className="fa fa-user" aria-hidden="true" />
                            <input
                                id="username" name="username" type="text"
                                autoComplete="username" placeholder="Enter user name"
                                value={username} onChange={(e) => setUsername(e.target.value)} required
                            />
                        </div>
                    </div>

                    <div className="lg-field">
                        <label htmlFor="password">Password</label>
                        <div className={`lg-input${errors.password ? " has-error" : ""}`}>
                            <i className="fa fa-lock" aria-hidden="true" />
                            <input
                                id="password" name="password"
                                type={showPassword ? "text" : "password"}
                                autoComplete="current-password" placeholder="Enter password"
                                value={password} onChange={(e) => setPassword(e.target.value)}
                                aria-invalid={!!errors.password} required
                            />
                            <button
                                type="button" className="lg-eye"
                                onClick={() => setShowPassword((s) => !s)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                            </button>
                        </div>
                        {errors.password && <p className="lg-error" role="alert">{errors.password}</p>}
                    </div>

                    <button type="submit" className="lg-submit" disabled={loading}>
                        {loading ? "Signing in…" : "Log in"}
                    </button>
                    {/*<Link to="/" className="lg-back">&larr; Back to home</Link>*/}
                </form>
            </div>
        </main>
    );
};

export default Login;